import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import { Link, NavLink } from 'react-router-dom';
import { UseCurrencyDecorator } from '../../../../../utilities/hooks/UseCurrencyDecorator';
import { useProviderCurrency } from '../../../../../utilities/hooks/useProviderCurrency';
import PropTypes from 'prop-types';
import { stripeLogin } from '../networking';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Tooltip from '../../../common/Tooltip';
import { AmountFormatHelper } from '../../../../../utilities/helpers/AmountFormatHelper';
import moment from 'moment';

const PayoutsOverview = ({ result, setShowLoader, providerInfo }) => {
	const dictionary = useDictionary();
	const currencyDecorator = UseCurrencyDecorator();
	const providerCurrency = useProviderCurrency();
	const currency = providerInfo?.currency ?? providerCurrency;
	const [verificationStatus, setVerificationStatus] = useState(null);
	const isUserVerified = verificationStatus === 3;
	const history = useHistory();
	
	useEffect(() => {
		if (providerInfo) {
			setVerificationStatus(providerInfo?.verification_status);
		}
	}, [providerInfo]);

	// if (!providerInfo) {
	// 	return null;
	// }

	const onDetailsClicked = async () => {
		history.push('/home/payouts');
	};
	const formatDate = (dateInsec) => {
		const date = new Date(dateInsec * 1000);
        return moment(date).format('MMM DD, YYYY');
	}

	return (
		<>
			<div className="payouts-title-row">
				<h2 data-testid="payouts-header" className='fw-500'>{dictionary.payouts}</h2>
				{isUserVerified && (
					<div
						style={{ cursor: 'pointer' }}
						className="see-details font-family-roboto fw-500 text-with-underline"
						data-testid="see-details"
						onClick={onDetailsClicked}
					>
						{dictionary.see_details}
					</div>
				)}
			</div>
			<div className="payout-container payout-container-home" data-testid="pending-payouts" style={{marginBottom: '8px'}}>
				<div className='payout-text-area'>
					<span className='payout-text font-family-roboto' style={{fontWeight:500}}>{dictionary.pending}</span>
					<div className='text-with-info provider-payout-info home-payout-info'> <Tooltip content={dictionary.upcoming_earnings} />
					</div>
				</div>
				<h3 style={{fontWeight: 400}}>{result ? currencyDecorator(AmountFormatHelper.formatAmount(result?.pending_balance), currency) : ''}</h3>
				<h4 style={{fontSize:'12px', opacity:'0.6'}} className='truncate fw-400'>{dictionary.estimated_upcoming} {currencyDecorator(AmountFormatHelper.formatAmount(providerInfo?.upcoming_payment?.amount), currency)} {providerInfo?.upcoming_payment?.amount !== 0 ? `(${dictionary.expected} ${formatDate(providerInfo?.upcoming_payment?.date)})` : ''}</h4>
			</div>

			<div className="payout-container payout-container-home" data-testid="available-payouts">
				<div className='payout-text-area'>
					<span className='payout-text font-family-roboto' style={{fontWeight:500}}>{dictionary.available}</span>
					<div className='text-with-info provider-payout-info home-payout-info'> <Tooltip content={dictionary.ready_to_withdraw} />
					</div>
				</div>
				<h3 style={{fontWeight: 400}}>{result ? currencyDecorator(AmountFormatHelper.formatAmount(result?.available_balance), currency) : ''}</h3>
				<h4 style={{fontSize:'12px', opacity:'0.6'}} className='truncate fw-400'>{dictionary.last_payment} {currencyDecorator(AmountFormatHelper.formatAmount(providerInfo?.last_payment?.amount), currency)} {providerInfo?.last_payment?.amount !== 0 ? `(${dictionary.received} ${formatDate(providerInfo?.last_payment?.date)})` : ''}</h4>
			</div>
		</>
	);
};

PayoutsOverview.propTypes = {
	result: PropTypes.object,
	setShowLoader: PropTypes.func,
	providerInfo: PropTypes.object
};

export default PayoutsOverview;
